import { PageLevel } from "@/pages/level";
import { PageLinkAccount } from "@/pages/link_account";
import { PageAboutus } from "@/pages/user/aboutus";
import { PageUserAccount } from "@/pages/user/account_passwd";
import { PageUserBill } from "@/pages/user/bill";
import { PageUserBillDetail } from "@/pages/user/bill_order_detail";
import { PageCentify } from "@/pages/user/centify";
import { PageDevices } from "@/pages/user/devices";
import { PageBindGoogleAuth } from "@/pages/user/google_auth/bind";
import { PageUnBindGoogleAuth } from "@/pages/user/google_auth/unbind";
import { PageNickname } from "@/pages/user/nickname";
import { PagePanic } from "@/pages/user/panic";
import { PageUserPwd } from "@/pages/user/passwd";
import { PageUserPhone } from "@/pages/user/phone";
import { PageUserReport } from "@/pages/user/report";
import { PageUserSecurity } from "@/pages/user/security";
import { PageUserTransfer } from "@/pages/user/transfer";
import { PageUserName } from "@/pages/user/username";
import { AuthUserRoute } from "../routesAuths/userAuth";

const userRoutes = [
  {
    path: "/user_bill",
    element: (
      <AuthUserRoute>
        <PageUserBill />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_transfer",
    element: (
      <AuthUserRoute>
        <PageUserTransfer />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_centify",
    element: (
      <AuthUserRoute>
        <PageCentify />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_security",
    element: (
      <AuthUserRoute>
        <PageUserSecurity />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_username",
    element: (
      <AuthUserRoute>
        <PageUserName />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_devices",
    element: (
      <AuthUserRoute>
        <PageDevices />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_report",
    element: (
      <AuthUserRoute>
        <PageUserReport />
      </AuthUserRoute>
    ),
  },
  {
    path: "/about",
    element: (
      <AuthUserRoute>
        <PageAboutus />
      </AuthUserRoute>
    ),
  },
  {
    path: "/panic",
    element: (
      <AuthUserRoute>
        <PagePanic />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_phone",
    element: (
      <AuthUserRoute>
        <PageUserPhone />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_login_psw",
    element: (
      <AuthUserRoute>
        <PageUserPwd />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_pay_psw",
    element: (
      <AuthUserRoute>
        <PageUserAccount />
      </AuthUserRoute>
    ),
  },
  {
    path: "/user_nickname",
    element: (
      <AuthUserRoute>
        <PageNickname />
      </AuthUserRoute>
    ),
  },
  {
    path: "/bind_google_auth",
    element: (
      <AuthUserRoute>
        <PageBindGoogleAuth />
      </AuthUserRoute>
    ),
  },
  {
    path: "/unbind_google_auth",
    element: (
      <AuthUserRoute>
        <PageUnBindGoogleAuth />
      </AuthUserRoute>
    ),
  },
  {
    path: "/level",
    element: (
      <AuthUserRoute>
        <PageLevel />
      </AuthUserRoute>
    ),
  },
  {
    path: "/bill_order_detail/:orderId",
    element: (
      <AuthUserRoute>
        <PageUserBillDetail />
      </AuthUserRoute>
    ),
  },
  {
    path: "/link_account",
    element: (
      <AuthUserRoute>
        <PageLinkAccount />
      </AuthUserRoute>
    ),
  },
  {
    path: "/auto_register",
    element: (
      <AuthUserRoute>
        <></>
      </AuthUserRoute>
    ),
  }
];
export default userRoutes;
